<template>
  <div class="minerve-step-three">
    <v-textarea
      v-model="form.part_to_order"
      filled
      name="Pièces à commander :"
      label="Pièces à commander :"
    />
    <v-layout
      justify-space-between
      mt-8
    >
      <v-flex
        v-for="(section, prop, index) in groupedArticles"
        :key="index"
        column
        sm6
      >
        <h2>{{ prop }}</h2>
        <v-layout
          v-for="article in section"
          :key="article.article_id"
          class="checkbox-input-container"
        >
          <v-flex>
            <v-checkbox
              v-model="form.articles[article.index].idc_want"
              hide-details
            >
              <template v-slot:label>
                <h4>{{ article.article_reference }}</h4>
                <h4>{{ article.label }}</h4>
              </template>
            </v-checkbox>
          </v-flex>
          <v-flex class="checkbox-input">
            <InputNumber
              v-if="article.idc_entry"
              v-model="form.articles[article.index].value"
              class="input-number"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        column
        sm6
      >
        <v-textarea
          v-model="form.other_lpr"
          filled
          name="Autre LPPR :"
          label="Autre LPPR :"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import InputNumber from "@/components/InputNumber.vue";

export default {
  name: "MinerveStepThree",
  inject: ["parentValidator"],
  components: {
    InputNumber
  },
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    groupedArticles: [],
    articlesList: []
  }),
  computed: {
    articles() {
      return this.articlesList.map(article => {
        return {
          article_id: article.article_id,
          idc_want: false,
          value: null
        };
      });
    }
  },
  async created() {
    this.$validator = this.parentValidator;

    const articles = await this.getLocalArticlesByModel("NECK_BRACE");
    this.articlesList = articles;
    this.groupedArticles = this.groupBy("section", articles);

    if (this.form.articles.length <= 0) {
      this.form.articles = this.articles;
    }
  },

  methods: {
    ...mapActions({
      getLocalArticlesByModel: "articles/getLocalArticlesByModel"
    }),

    // Group array of objects by property value
    groupBy(property, array) {
      return array.reduce((objectsByKeyValue, obj, index) => {
        const value = obj[property];
        obj.index = index;
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
      }, {});
    }
  }
};
</script>

<style lang="scss">
.minerve-step-three {
  .v-input--selection-controls {
    &.v-input {
      .v-input__control {
        flex-grow: 1;
      }
      .v-label {
        width: 100%;
      }
    }
    .v-input__slot {
      align-items: flex-start;
      .v-label {
        align-items: baseline;
      }
    }
  }
  .v-input {
    .v-input__control {
      .v-input__slot {
        height: auto;
      }
    }
  }
  .checkbox-input-container {
    margin-top: 0;
    > div {
      &.checkbox-input {
        position: relative;
        top: 0;
        transform: none;
        margin-left: 15px;
        max-width: 80px !important;
      }
    }
  }
  .v-input--selection-controls {
    margin-top: 0;
    &.v-input {
      .v-input__control {
        flex-grow: 1;
      }
      .v-label {
        width: 100%;
        h4 {
          font-size: 10px !important;
          &:first-child {
            color: #333;
            margin-right: 5px;
            font-size: 12px !important;
          }
        }
      }
    }
    .v-input__slot {
      align-items: flex-start;
      overflow: hidden;
      margin-bottom: 15px;
      height: 35px !important;
      .v-label {
        align-items: baseline;
      }
    }
  }
}
</style>
